import dragHandle from '../assets/drag-handle-icon.png'

export default function DragHandle ({id}) {

    return <span className='list-item-drag-handle' data-id={id} ><img src = {dragHandle} draggable={false} /></span>
};